import React, { memo } from 'react'
import { useTranslation } from 'react-i18next'
import { getRoomName } from '../../common'
import RoomCodes from '../RoomCodes'
import RoomImageBrowser from '../RoomImageBrowser'

const RoomRow = memo((
  {
    roomAttributes, room, roomImages,
    isExpanded, showCodes, onExpandToggle,
    onRoomSelected, onRoomDeleteClick,
    uploadQueue,
    onUploadFiles,
    onUploadQueueImageRemove
  }) => {
  const { t } = useTranslation()
  return (
    <div className={'room-list-room-row'}>
      <div className={'room-list-room-row-content'}>
        <div>
          <div className={'room-list-room-row-header'}>
            <div>
            <span className={'room-list-room-row-name'}
                  onClick={() => onExpandToggle(room)}>{getRoomName(roomAttributes, room)}</span>
              <span className={'room-list-room-row-name-extra-info'}>({roomImages.length} {t('IMAGES')})</span>
            </div>
            <div className={'room-list-room-row-actions'}>
            <span className={'icon-wrapper'} onClick={() => onRoomSelected(room)}>
              <i className="giata-icon-edit" title={t('BUTTON_EDIT')}/>
            </span>
              <span className={'icon-wrapper'} onClick={() => onExpandToggle(room)}>
              <i className={isExpanded ? 'giata-icon-arrow-up' : 'giata-icon-arrow-down'}/>
            </span>
            </div>
          </div>
          {showCodes &&
            <RoomCodes room={room}/>
          }
          {isExpanded && <RoomImageBrowser
            room={room} images={roomImages}
            uploadQueue={uploadQueue}
            onUploadFiles={onUploadFiles}
            onUploadQueueImageRemove={onUploadQueueImageRemove}/>
          }
          <hr/>
        </div>
        <div className={'room-list-spacer'}>
        <span className={'icon-wrapper'} onClick={() => onRoomDeleteClick(room)}>
            <i className="giata-icon-trash" title={t('BUTTON_DELETE')}/>
        </span>
        </div>
      </div>
    </div>
  )
})

export default RoomRow
